// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import SafetyHookListResultModel from '../../model/safety-hook-list-result-model';
import SafetyHookListResultDTO from '../dto/safety-hook-list-result-dto';
import dtoSchema from '../schemas/safety-hook-list-result-schema';
import SafetyHookModel from '../../model/safety-hook-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class SafetyHookListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<SafetyHookListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => SafetyHookModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: SafetyHookModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<SafetyHookListResultDTO>): SafetyHookListResultModel;
  static toModel(dto: DeepPartial<SafetyHookListResultDTO> | undefined | null): SafetyHookListResultModel | undefined;
  static toModel(dto: DeepPartial<SafetyHookListResultDTO> | undefined | null): SafetyHookListResultModel | undefined {
    return dto ? new SafetyHookListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<SafetyHookListResultModel> | SafetyHookListResultModel): SafetyHookListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as SafetyHookListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for SafetyHookListResultModel, can not map to SafetyHookListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
